import React from "react";
import "./styles.css";

export interface LoaderProps {
  size?: "small" | "medium" | "large";
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = "medium", className = "" }) => {
  return <div className={`loader loader--${size} ${className}`} />;
};

export default Loader;

